import { useState, useRef, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import useRetryFetch from "../../../../hooks/useRetryFetch";
import { useEffectOnce } from "../../../../hooks/useEffectOnce";
import { config } from "../../../../Environment";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../../components/ui/dialog";
import { Button } from "../../../../components/ui/button";
import {
  ShoppingCart,
} from "lucide-react";
import { decimalAmount, currencyAmount } from "../../../../lib/currency";

function displayDateFromTimestamp(ts: string) {
  // moment(activityLastUpdatedDate).fromNow() always shows in English, need to localize if we will use it
  const d = new Date(ts);
  const year = d.getFullYear();
  const yearText = String(year).padStart(4, "0");
  const month = d.getMonth();
  const monthText = String(month).padStart(2, "0");
  const dayOfMonth = d.getDate();
  const dayOfMonthText = String(dayOfMonth).padStart(2, "0");
  if (
    !Number.isInteger(year) ||
    !Number.isInteger(month) ||
    !Number.isInteger(dayOfMonth)
  ) {
    return null;
  }
  return `${yearText}-${monthText}-${dayOfMonthText}`;
}

function BuySubscriptionModal({ productInfo, buySubscriptionModalVisible, setBuySubscriptionModalVisible }: any) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const retryFetch = useRetryFetch();

  const [existingItem, setExistingItem] = useState<any>(null);

  console.log(`buysbuscasdfitponi modal ${JSON.stringify(productInfo)}`);

  async function loadUserSubscriptions() {
    const query = new URLSearchParams();
    query.set('vendorId', productInfo.fiVendor);
    query.set('productId', productInfo.fiSubscription);
    const response = await retryFetch(`${config.API_BASE}/api/user/subscription/search?${query.toString()}`);
    const result = await response.json();
    let found = false;
    if (Array.isArray(result.list) && result.list.length > 0) {
      for (let i = 0; i < result.list.length; i += 1) {
        const item = result.list[i];
        console.log(`loadUserSubscriptions item ${JSON.stringify(item)}`);
        if (item.fiSubscription === productInfo._id) {
          found = true;
          setExistingItem(item);
        }
      }
    }
    console.log(`SO SDFAOSJKD F;LAKJD F;LKASDJ FL;KASJ FD;L fond ${found}`);

    if (!found) {
      // user has not yet subscribed to item so skip the dialog and redirect to the checkout
      setBuySubscriptionModalVisible(false);
      buySubscription();
    }
  }

    useEffectOnce(() => {
      loadUserSubscriptions();
    }, []);
  
  function buySubscription() {
    navigate(`/buy?productId=${productInfo._id}`);
  }

  function renderAlreadySubscribed() {
    if (!existingItem) {
      return (<></>);
    }
    return (
          <div className="space-y-3">
            {/* <h3 className="text-sm font-medium">{t("label_created_by")}</h3> */}
            <p>You already have this subscription.</p>
          </div>
    );
  }

  // format is purchase price (if > 0) + recurring price / interval
  function renderPrice() {
    const purchasePrice = productInfo.price;
    const recurringPrice = productInfo.data.subscription.recurringPrice;
    const parts = [];
    if (purchasePrice.amount) {
      parts.push(currencyAmount(purchasePrice.amount, purchasePrice.currency));
    }
    parts.push(currencyAmount(recurringPrice.amount, recurringPrice.currency) + "/" + t(recurringPrice.interval));
    const text = parts.join(" + ");
    return text;
  }

  function renderBuySubscription() {
    if (existingItem) {
      return (<></>);
    }
    return (
          <div className="space-y-3">
            <h3 className="text-sm font-medium">{t("action_get_started", "Get Started")}</h3>
            <div className="flex items-start gap-3">
              <Button
                size="sm"
                onClick={() => {
                  buySubscription();
                }}
              >
                <ShoppingCart className="h-4 w-4 mr-1" />
                {t("action_get_started", "Get Started")}
              </Button>
              <span style={{fontSize: "1.1em", fontWeight: "bold"}}>
                {renderPrice()}
              </span>

            </div>
          </div>
    );
  }


    return (
      <Dialog
        open={buySubscriptionModalVisible}
        onOpenChange={setBuySubscriptionModalVisible}
      >
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{t("subscription")}</DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
            <div className="space-y-3">
                <h3 className="text-sm font-medium">{t("name")}</h3>
                <p>{productInfo.name}</p>
            </div>

          {renderAlreadySubscribed()}
          {renderBuySubscription()}

        </div>
      </DialogContent>
        </Dialog>
    );
}

export default BuySubscriptionModal;